module.exports = __webpack_public_path__ + "static/media/main2_zh.5dff6886.png";